module.exports = __webpack_public_path__ + "media/gai06.8d841831.mp3";